import usePutSessionFormInitialEmail from './usePutSessionFormInitialEmail'

export default usePutSessionFormInitialEmail
